import {
	IconPassport,
	IconPerson,
	IconPin,
	IconTime,
	IconTimelineStop,
} from '@flixbus/honeycomb-icons-react';

import { CREATE_BREAKDOWN_FLOW_TEXT } from 'pages/WorkAssignments/components/CreateBreakdownFlow/texts';
import { formatSummaryDateTime } from 'utils/datetime/fnsTimeFormatter';

import { BREAKDOWN_DETAILS_MODAL_TEXT } from '../text';

const LABELS = CREATE_BREAKDOWN_FLOW_TEXT.summary.rowLabels;

/**
 * Build the "Replacement driver info" rows from an accepted breakdown.
 * Uses `inboundTravelingWorkAssignment` for the ETD/ETA + departure city.
 *
 * @param {object} breakdown
 * @returns {import('common/BreakdownDetails').BreakdownDetailsRow[]}
 */
export const deriveReplacementDriverRowsFromBreakdown = (breakdown) => {
	if (breakdown?.parallelRide) return [];

	const driver = breakdown?.replacementCrewMember;
	const inbound = breakdown?.inboundTravelingWorkAssignment;

	if (!driver && !inbound) return [];

	return [
		{
			label: LABELS.departureLocation,
			value: inbound?.fromStation?.name ?? '',
			icon: IconPin,
		},
		{
			label: LABELS.replacementDriverName,
			value: driver?.fullName ?? '',
			icon: IconPerson,
		},
		{
			label: LABELS.replacementDriverId,
			value: driver?.driverCard ?? BREAKDOWN_DETAILS_MODAL_TEXT.notAvailable,
			icon: IconPassport,
		},
		{
			label: LABELS.replacementEtd,
			value: formatSummaryDateTime(inbound?.fromTimestamp),
			icon: IconTime,
		},
		{
			label: LABELS.replacementEta,
			value: formatSummaryDateTime(inbound?.toTimestamp),
			icon: IconTimelineStop,
		},
	];
};
